var map = {
	"./banner-home-1.jpg": 392,
	"./banner-home-2.jpg": 393,
	"./banner-home.jpg": 394,
	"./benedict-1.jpg": 395,
	"./benedict-2.jpg": 396,
	"./benedict-3.jpg": 397,
	"./benedict-4.jpg": 398,
	"./benedict-5.jpg": 399,
	"./benedict-cover.jpg": 400,
	"./bistecca-1.jpg": 401,
	"./bistecca-2.jpg": 402,
	"./bistecca-3.jpg": 403,
	"./bistecca-4.jpg": 404,
	"./bistecca-cover.jpg": 405,
	"./bottled_cocktails.jpg": 406,
	"./caffe-milano-1.jpg": 407,
	"./caffe-milano-2.jpg": 408,
	"./caffe-milano-3.jpg": 409,
	"./caffe-milano-4.jpg": 410,
	"./caffe-milano-cover.jpg": 411,
	"./cake.jpg": 412,
	"./cocktail.jpg": 413,
	"./cs-1.jpg": 414,
	"./cs-2.jpg": 415,
	"./cs-3.jpg": 416,
	"./cs-4.jpg": 417,
	"./cs-cover.jpg": 418,
	"./cscc-1.jpg": 419,
	"./cscc-2.jpg": 420,
	"./cscc-3.jpg": 421,
	"./cscc-4.jpg": 422,
	"./cscc-5.jpg": 423,
	"./cscc-6.jpg": 424,
	"./cscc-cover.jpg": 425,
	"./home_delivery.jpg": 426,
	"./homedelivery.jpg": 427,
	"./loewy logo-04.png": 428,
	"./loewy-1.jpg": 429,
	"./loewy-2.jpg": 430,
	"./loewy-3.jpg": 431,
	"./loewy-cover.jpg": 432,
	"./pierre-1.jpeg": 433,
	"./pierre-2.jpeg": 434,
	"./pierre-3.jpeg": 435,
	"./pierre-4.jpeg": 436,
	"./pierre-5.jpeg": 437,
	"./pierre-cover.jpeg": 438,
	"./pizza-milano-1.jpg": 439,
	"./pizza-milano-2.jpg": 440,
	"./pizza-milano-3.jpg": 441,
	"./pizza-milano-4.jpg": 442,
	"./pizza-milano-cover.jpg": 443,
	"./roma-1.jpeg": 444,
	"./roma-1.jpg": 445,
	"./roma-2.jpeg": 446,
	"./roma-2.jpg": 447,
	"./roma-3.jpeg": 448,
	"./roma-3.jpg": 449,
	"./roma-4.jpeg": 450,
	"./roma-cover.jpeg": 451,
	"./shiraz_package.jpg": 452,
	"./spirit.jpg": 453,
	"./the-dutch-1.jpg": 454,
	"./the-dutch-2.jpg": 455,
	"./the-dutch-3.jpg": 456,
	"./the-dutch-4.jpg": 457,
	"./the-dutch-5.jpg": 458,
	"./the-dutch-6.jpg": 459,
	"./the-dutch-7.jpg": 460,
	"./the-dutch-cover.jpg": 461,
	"./tugwecare.jpg": 462,
	"./union-1.jpg": 463,
	"./union-2.jpg": 464,
	"./union-3.jpg": 465,
	"./union-4.jpg": 466,
	"./union-cover.jpg": 467,
	"./wine.jpg": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;